module.exports = __webpack_public_path__ + "static/durazno5-de65353c325df6d4537e3603721801b4.jpg";